export default function PoliceJobOpenings () {
    return (
    <div>

<div className="police-bg bg-image">
            <div className="gap-spacer"></div>
            <div className="page-title mobile-center-title top-cap-outlines">
                <h1>Morrisville Borough Police</h1>
            </div>
            {/*Start Main Content*/}
            <div className="police-center-container mid-side-outlines">
                
                
                
                 {/*Start Police Sub-Menu*/}
                 <div className="police-sub-menu">
                    <div className="logo"></div>
                    <input className="menu-btn" type="checkbox" id="menu-btn"/>
                    <label className="menu-icon" for="menu-btn"><i className="fa-solid fa-bars"></i>&nbsp;Police Sub-Menu</label>
                    <ul className="menu">
                        <li><a href="/police">General</a></li>
                        <li><a href="https://bucks.crimewatchpa.com/morrisvillepd/34776">CrimeWatch&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                        <li><a href="/police/documents">Documents</a></li>
                        <li><a href="/police/jobs">Jobs</a></li>
                        <li><a href="/police/personnel">Personnel</a></li>
                        <li><a href="/police/resources">Resources</a></li>
                        <li><a href="https://bucks.crimewatchpa.com/morrisvillepd/34776/submit-tip">Submit-A-Tip&nbsp;<i className="fa-solid fa-arrow-up-right-from-square"></i></a></li>
                        <li><a href="/police/statistics">Statistics</a></li>
                    </ul>
                </div>
                {/*End Police Sub-Menu*/}

            
            {/*Start Section Below Sub-Menu*/}


            
                    <p className="max-width-center"><br/>
<h2 style={{ textAlign: "center"}}>Job Openings</h2>
<script type="text/javascript" src="https://www.PoliceApp.com/Jobs/Boards/Dept/1230/Police-Jobs/script.js"></script>
<iframe src="https://www.PoliceApp.com/Jobs/Boards/Dept/1230/Police-Jobs/"  title="PoliceApp listing of Police related job postings by Morrisville Borough" style={{ width:"100%",minHeight:"400vh",textAlign: "center",border:"none" }}></iframe>
</p>

                </div>



                {/*Start Section Below Sub-Menu*/}

            <div className="page-footer bottom-cap-outlines">&nbsp;</div>
            <div className="gap-spacer"></div>
            <div className="gap-spacer"></div>

            </div>
            
            


</div>
    )
}